import { useNavigate } from 'react-router-dom';
import useDriversData from '../../hooks/react-query/useDrivers';
import DriverCard from '../drivers/driverCard';
import { useModalStore } from '../../store/modalStore';

export const DriversSection = ({ className = '' }) => {
  const navigate = useNavigate();

  const { data, isLoading } = useDriversData();
  const {setModalToOpen} = useModalStore()

  return (
    <div className="flex w-full lg:bg-[#FFFFFF99] lg:rounded-[12px] lg:p-6 flex-col gap-[10px] lg:min-h-[298px]">
      <div className="w-full flex justify-between items-center">
        <h3>Οδηγοί</h3>
        <button onClick={() => navigate('/drivers')}>
          <h6 className="text-primary">Προβολή όλων</h6>
        </button>
      </div>
      <div className="grid lg:grid-cols-3 max-lg:bg-powdergrey gap-[10px] max-lg:p-5 max-lg:rounded-[12px]">
        {isLoading
          ? Array.from({ length: 9 }, (_, index) => (
              <div
                ke={index}
                className={
                  'p-3 animate-pulse bg-white flex w-full items-center gap-3 rounded-lg'
                }
              >
                <div
                  className={'rounded-full bg-powdergrey w-10 h-10 leading-10'}
                />
                <div className="flex flex-col gap-2">
                  <div className="w-20 h-5 bg-powdergrey rounded-full" />
                  <div className="w-40 h-5 bg-powdergrey rounded-full" />
                </div>
              </div>
            ))
          : data &&  data.data.length > 0 ? 
            data.data
              .slice(0, 9)
              .map((driver) => (
                <DriverCard
                  driverDetails={driver}   
                  key={driver.id}
                  className={className}
                />
              )) :
              <div className="flex flex-col col-span-3 text-center gap-1">
                  <p className="text-body">Δεν υπάρχουν καταχωρίσεις.</p>
                  <h6 className="text-[#6A6A6A]">
                    Πρόσθεσε οδηγούς για να εμφανιστούν στη λίστα.
                  </h6>
                </div>
            }
      </div>
      <div className='flex w-full justify-end'>
        <button className='bg-primary max-lg:w-full py-3 px-10 text-primary-button text-white rounded-[6px]' onClick={() => {setModalToOpen('add'); navigate('/drivers')}}>
            Καταχώριση
          </button>
      </div>
    </div>
  );
};
